<template>
  <div class="wrapper-campaigndetail">
    <!-- Support PC Tablet -->
    <div v-if="windowWidth >= 600 && windowHeight >= 600" class="h-100">
      <div
        class="image__hearder"
        crm_at="image_hearder"
        :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
      >
        <div class="box_content">
          <div class="wrapper__campaigndetail__page">
            <a href="/home" class="image-back" crm_at="btn_back_home">
              <img src="@/assets/images/Btn_Back.svg" alt="" />
            </a>
            <div class="row content_page">
              <div class="col-5">
                <div class="box-img">
                  <img
                    class="img-campaign"
                    crm_at="img_campaign"
                    alt=""
                    :src="imgCampaign"
                  />
                </div>
              </div>
              <div class="col-7">
                <div
                  class="box-label-detail"
                  :class="{ 'box-label-detail-package': isTypePackage }"
                >
                  <div v-if="isTypePackage" class="qty">
                    <span class="prefix">x</span>
                    <span class="number">
                      {{ packageQTY ? packageQTY : 0 }}
                    </span>
                  </div>
                  <label crm_at="label_name" style="text-align: left;">
                    {{ this.labelName }}
                  </label>
                </div>
                <div
                  class="use-points pt-2"
                  :class="{
                    'detail-package': isTypePackage,
                  }"
                >
                  <a-button
                    v-if="isStore == 'point' && type != 16"
                    shape="round"
                    class="btn-crm-l btn-use-points event-none"
                    crm_at="btn_point"
                    :style="{
                      'background-color': '#fff',
                      'border-color': backgroundPointColor
                        ? backgroundPointColor
                        : '#6ace74',
                      color: backgroundPointColor
                        ? backgroundPointColor
                        : '#6ace74',
                    }"
                  >
                    <span v-if="PointPerUnit <= 0 && type != 8">
                      {{ lbl.main.free }}
                    </span>
                    <span v-else-if="this.Campaign.data.PointType == 'use'">
                      {{ lbl.main.use }} {{ PointPerUnit }}
                      {{ lbl.main.points }}
                    </span>
                    <span v-else-if="type == 8">
                      {{ lbl.default.join }}
                    </span>
                    <span v-else>
                      {{ lbl.main.use }} {{ PointPerUnit }}
                      {{ lbl.main.points }}
                    </span>
                  </a-button>
                  <div v-if="isTypePackage" class="expire">
                    {{ lbl.main.expired_on_text + ': ' }}
                    {{ dateShortFormatUTC(ExpireDate, true) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <a-tabs
                  default-active-key="1"
                  crm_at="tabs"
                  @change="changeTabs"
                >
                  <a-tab-pane key="1" crm_at="tab_detail">
                    <span slot="tab" crm_at="btn_description">
                      {{ lbl.campaigndetail.description }}
                    </span>
                    <div id="id_detail" class="box-detail">&nbsp;</div>
                  </a-tab-pane>
                  <a-tab-pane key="2" crm_at="tab_terms_and_condition">
                    <span slot="tab" crm_at="btn_terms_and_condition">
                      {{ lbl.campaigndetail.terms_and_condition }}
                    </span>
                    <div id="id_terms" class="box-detail">&nbsp;</div>
                  </a-tab-pane>
                </a-tabs>
              </div>
            </div>
            <footer class="footer mt-5 mb-2">
              <div class="row">
                <div class="col-12">
                  <div class="container not-locale">
                    <a
                      v-if="type != 16"
                      class="menu menu-resize"
                      :disabled="isContinue"
                      :class="{ continue: isContinue }"
                      crm_at="btn_redeem"
                      :style="{
                        'background-color': backgroundColor
                          ? backgroundColor
                          : '#1890ff',
                        'border-color': backgroundColor
                          ? backgroundColor
                          : '#1890ff',
                      }"
                      @click="handleRedeem"
                    >
                      <label
                        v-if="isPointNot && type != 0"
                        class="btn-redeem-not"
                        crm_at="label_point_not_enough"
                        :style="{ color: textColor ? textColor : '#FFF' }"
                      >
                        {{ lbl.campaigndetail.point_not_enough }}
                      </label>
                      <label
                        v-else-if="isConditionAlert && type != 0"
                        class="btn-redeem-alert"
                        crm_at="label_condition"
                        :style="{ color: textColor ? textColor : '#FFF' }"
                      >
                        {{ ConditionAlert }}
                      </label>
                      <label
                        v-else-if="type == 0 && isPointNot"
                        class="btn-redeem-not"
                        crm_at="label_point_not_enough"
                        :style="{ color: textColor ? textColor : '#FFF' }"
                      >
                        {{ lbl.lucky_draw.point_not_enough }}
                      </label>
                      <label
                        v-else-if="type == 0"
                        class="btn-redeem"
                        crm_at="label_redeem_now"
                        :style="{ color: textColor ? textColor : '#FFF' }"
                      >
                        {{ lbl.lucky_draw.button_submit }}
                      </label>
                      <label
                        v-else
                        class="btn-redeem"
                        crm_at="label_redeem_now"
                        :style="{ color: textColor ? textColor : '#FFF' }"
                      >
                        {{ lbl.btn.redeem_now }}
                      </label>
                    </a>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
    <!-- Support Mobile -->
    <div v-else>
      <a href="/home" class="image-back" crm_at="btn_back_home">
        <img src="@/assets/images/Btn_Back.svg" alt="" />
      </a>
      <div class="row wrapper-detail">
        <div class="col-12 text-center">
          <div class="box-img">
            <img
              class="img-campaign"
              crm_at="img_campaign"
              alt=""
              :src="imgCampaign"
            />
          </div>
          <div
            class="box-label-detail"
            :class="{ 'box-label-detail-package': isTypePackage }"
          >
            <div v-if="isTypePackage" class="qty">
              <span class="prefix">x</span>
              <span class="number">
                {{ packageQTY ? packageQTY : 0 }}
              </span>
            </div>
            <label crm_at="label_name" style="text-align: left;">
              {{ this.labelName }}
            </label>
          </div>
          <div
            class="use-points pt-2"
            :class="{
              'detail-package': isTypePackage,
            }"
          >
            <a-button
              v-if="isStore == 'point' && type != 16"
              type="primary"
              shape="round"
              class="btn-crm-l btn-use-points event-none"
              crm_at="btn_point"
              :style="{
                'background-color': backgroundPointColor
                  ? backgroundPointColor
                  : '#1890ff',
                'border-color': backgroundPointColor
                  ? backgroundPointColor
                  : '#1890ff',
                color: textPointColor ? textPointColor : '#FFF',
              }"
            >
              <span v-if="PointPerUnit <= 0 && type != 8">
                {{ lbl.main.free }}
              </span>
              <span v-else-if="this.Campaign.data.PointType == 'use'">
                {{ lbl.main.use }} {{ PointPerUnit }}
                {{ lbl.main.points }}
              </span>
              <span v-else-if="type == 8">
                {{ lbl.default.join }}
              </span>
              <span v-else
                >{{ lbl.main.use }} {{ PointPerUnit }}
                {{ lbl.main.points }}</span
              >
            </a-button>
            <div v-if="isTypePackage" class="expire">
              {{ lbl.main.expired_on_text + ': ' }}
              {{ dateShortFormatUTC(ExpireDate, true) }}
            </div>
          </div>
          <div class="pt-3">
            <a-tabs default-active-key="1" crm_at="tabs" @change="changeTabs">
              <a-tab-pane key="1" crm_at="tab_detail">
                <span slot="tab" crm_at="btn_description">
                  {{ lbl.campaigndetail.description }}
                </span>
                <div id="id_detail" class="box-detail">&nbsp;</div>
              </a-tab-pane>
              <a-tab-pane key="2" crm_at="tab_terms_and_condition">
                <span slot="tab" crm_at="btn_terms_and_condition">
                  {{ lbl.campaigndetail.terms_and_condition }}
                </span>
                <div id="id_terms" class="box-detail">&nbsp;</div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>

      <!-- Button Redeem -->
      <footer class="footer">
        <div class="row">
          <div class="col-12">
            <div class="container not-locale">
              <a
                v-if="type != 16"
                class="menu menu-resize"
                :disabled="isContinue"
                :class="{ continue: isContinue }"
                crm_at="btn_redeem"
                :style="{
                  'background-color': backgroundColor
                    ? backgroundColor
                    : '#1890ff',
                  'border-color': backgroundColor ? backgroundColor : '#1890ff',
                }"
                @click="handleRedeem"
              >
                <label
                  v-if="isPointNot && type != 0"
                  class="btn-redeem-not"
                  crm_at="label_point_not_enough"
                  :style="{ color: textColor ? textColor : '#FFF' }"
                >
                  {{ lbl.campaigndetail.point_not_enough }}
                </label>
                <label
                  v-else-if="isConditionAlert && type != 0"
                  class="btn-redeem-alert"
                  crm_at="label_condition"
                  :style="{ color: textColor ? textColor : '#FFF' }"
                >
                  {{ ConditionAlert }}
                </label>
                <label
                  v-else-if="type == 0 && isPointNot"
                  class="btn-redeem-not"
                  crm_at="label_point_not_enough"
                  :style="{ color: textColor ? textColor : '#FFF' }"
                >
                  {{ lbl.lucky_draw.point_not_enough }}
                </label>
                <label
                  v-else-if="type == 0"
                  class="btn-redeem"
                  crm_at="label_redeem_now"
                  :style="{ color: textColor ? textColor : '#FFF' }"
                >
                  {{ lbl.lucky_draw.button_submit }}
                </label>
                <label
                  v-else
                  class="btn-redeem"
                  crm_at="label_redeem_now"
                  :style="{ color: textColor ? textColor : '#FFF' }"
                >
                  {{ lbl.btn.redeem_now }}
                </label>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <!-- Popup Confirm -->
    <b-modal
      ref="my-modal-confirm"
      crm_at="modal_confirm"
      centered
      class="modal-Confirm"
    >
      <template #modal-header="{ close }" :class="currentLocale">
        <h5
          class="modal-title"
          :class="[currentLocale == 'th' ? 'th' : 'en']"
          crm_at="title_redeem_confirmation"
        >
          {{ lbl.campaigndetail.redeem_confirmation }}
        </h5>
        <b-button
          size="lg"
          class="b-modal-header"
          :class="[currentLocale == 'th' ? 'th' : 'en']"
          crm_at="close_modal_confirm"
          @click="close()"
        >
          <a-icon type="close" />
        </b-button>
      </template>
      <div class="row" :class="currentLocale">
        <div class="col-12 text-center pt-4 pb-4" crm_at="label_are_you_sure">
          {{ lbl.campaigndetail.are_you_sure }}
        </div>
      </div>
      <template #modal-footer :class="currentLocale">
        <div class="row w-100">
          <div class="col-12 text-center">
            <a-button
              key="back"
              shape="round"
              class="btn-cancel mr-2"
              :class="[currentLocale == 'th' ? 'th' : 'en']"
              crm_at="btn_cancel_modal_confirm"
              @click="handleCancel"
            >
              {{ lbl.default.cancel }}
            </a-button>
            <a-button
              key="submit"
              shape="round"
              class="btn-confirm ml-2"
              :class="[currentLocale == 'th' ? 'th' : 'en']"
              crm_at="btn_submit_modal_confirm"
              :style="{
                'background-color': backgroundColor
                  ? backgroundColor
                  : '#1890ff',
                'border-color': backgroundColor ? backgroundColor : '#1890ff',
                color: textColor ? textColor : '#FFF',
              }"
              @click="handleConfirm"
            >
              {{ lbl.default.confirm }}
            </a-button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Popup Barcode -->
    <Barcode
      :show="showBarcode"
      :data="dataBarcode"
      @changeBarcode="ChangeBarcode($event)"
    />

    <!-- Popup Edit Address -->
    <AddressEdit :show="showAddress" @changeAddress="ChangeAddress($event)" />

    <!-- Popup Save Address Success -->
    <b-modal
      id="modal-save-address-success"
      ref="my-modal-save-address-success"
      centered
      crm_at="btn_modal_address_success"
      class="modal-SaveAddressSuccess"
    >
      <template #modal-header="{ close }" :class="currentLocale">
        <h5 class="modal-title" crm_at="title_modal_address_success">
          {{ lbl.campaigndetail.redeem_confirmed }}
        </h5>
        <b-button
          size="lg"
          class="b-modal-header"
          crm_at="close_modal_address_success"
          @click="close()"
        >
          <a-icon type="close" />
        </b-button>
      </template>
      <div class="row" :class="currentLocale">
        <div class="col-12 text-center pt-4 pb-4" crm_at="label_order_days">
          {{ lbl.campaigndetail.order_days }}
        </div>
      </div>
      <template #modal-footer :class="currentLocale">
        <div class="row w-100">
          <div class="col-12 text-center">
            <a-button
              key="submit"
              shape="round"
              class="btn-confirm ml-2"
              crm_at="btn_submit_modal_address_success"
              href="/home"
              :style="{
                'background-color': backgroundColor
                  ? backgroundColor
                  : '#1890ff',
                'border-color': backgroundColor ? backgroundColor : '#1890ff',
                color: textColor ? textColor : '#FFF',
              }"
            >
              {{ lbl.btn.ok }}
            </a-button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Modal select type Package -->
    <div v-if="isShowModalSelectPackage" class="wrapper-popup-select-package">
      <div class="mask-popup-select-package"></div>
      <div class="popup-select-package">
        <div class="top">
          <div class="title">
            <strong>
              {{ lbl.campaigndetail.modal_select_campaign_package_title }}
            </strong>
            <div class="qty">
              <span class="prefix">x</span>
              <span class="number">
                {{ packageQTY ? packageQTY : 0 }}
              </span>
            </div>
          </div>
          <div class="close" @click="isShowModalSelectPackage = false">
            <img src="@/assets/images/close_gray.svg" alt="close" />
          </div>
        </div>
        <div class="center">
          <div v-for="i in packageQTY" :key="i" class="campaign-card">
            <div class="box-img m-0">
              <img
                class="img-campaign"
                crm_at="img_campaign"
                alt="img_campaign"
                :src="imgCampaign"
              />
            </div>
            <div class="detail">
              <a-tooltip
                placement="topLeft"
                :title="labelName"
                arrow-point-at-center
              >
                <strong class="name"> {{ labelName }}</strong>
              </a-tooltip>
              <span class="expire">
                {{ lbl.main.expired_on_text + ': ' }}
                {{ dateShortFormatUTC(PackageVoucherExpireDate, true) }}
              </span>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="package-noted">
            <span>
              {{
                displayIncludeReward(lbl.campaigndetail.package_include_reward)
              }}
            </span>
            <span>
              {{ lbl.main.expired_on_text + ': ' }}
              {{ dateExpirePackage(ExpireDate, true) }}
            </span>
          </div>
          <a
            v-if="type != 16"
            class="btn-redeem-package"
            :disabled="isContinue"
            :class="{ continue: isContinue }"
            crm_at="btn_redeem"
            :style="{
              'background-color': backgroundColor ? backgroundColor : '#1890ff',
              'border-color': backgroundColor ? backgroundColor : '#1890ff',
            }"
            @click="handleRedeemPackage"
          >
            <label
              v-if="isPointNot && type != 0"
              class="btn-redeem-not"
              crm_at="label_point_not_enough"
              :style="{ color: textColor ? textColor : '#FFF' }"
            >
              {{ lbl.campaigndetail.point_not_enough }}
            </label>
            <label
              v-else-if="isConditionAlert && type != 0"
              class="btn-redeem-alert"
              crm_at="label_condition"
              :style="{ color: textColor ? textColor : '#FFF' }"
            >
              {{ ConditionAlert }}
            </label>
            <label
              v-else-if="type == 0 && isPointNot"
              class="btn-redeem-not"
              crm_at="label_point_not_enough"
              :style="{ color: textColor ? textColor : '#FFF' }"
            >
              {{ lbl.lucky_draw.point_not_enough }}
            </label>
            <label
              v-else
              crm_at="label_redeem_now"
              :style="{ color: textColor ? textColor : '#FFF' }"
            >
              {{ lbl.default.confirm }}
            </label>
          </a>
        </div>
      </div>
    </div>

    <!-- Modal redeem package success -->
    <a-modal
      v-model="isShowModalRedeemPackageSuccess"
      :closable="false"
      :mask-closable="false"
      :title="null"
      :footer="null"
      centered
      class="redeem-package-success-modal"
    >
      <div class="header">
        <img
          src="@/assets/images/redeem_package_success.svg"
          alt="success icon"
          class="icon"
        />
      </div>
      <div class="content">
        <strong class="title">
          {{ lbl.campaigndetail.title_redeem_success_modal }}
        </strong>
        <div class="campaign-name">
          <span>{{ labelName }}</span>
          <span class="qty">
            {{ packageQTY ? 'x' + packageQTY : 'x0' }}
          </span>
        </div>
      </div>
      <div class="footer m-0 p-0">
        <a-button
          crm_at="btn_go_rewards"
          :style="{
            'background-color': backgroundColor ? backgroundColor : '#1890ff',
            'border-color': backgroundColor ? backgroundColor : '#1890ff',
            color: textColor ? textColor : '#FFF',
          }"
          class="btn-go-rewards"
          @click="goRewards"
        >
          {{ lbl.campaigndetail.go_my_rewards }}
        </a-button>
      </div>
    </a-modal>
    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />

    <SendVerifyEmail
      :show="showSendVerifyEmail"
      @changeSendVerifyEmail="ChangeSendVerifyEmail($event)"
    />

    <!-- LuckyDraw -->
    <ConfirmLuckyDraw
      :show="showConfirmLuckyDraw"
      :data="dataConfirmLuckyDraw"
      @closeLuckyDraw="closeLuckyDraw($event)"
      @submitConfirm="submitConfirm($event)"
    />
    <SuccessLuckyDraw
      :show="showSuccessLuckyDraw"
      :data="dataSuccessLuckyDraw"
      @successLuckyDraw="successLuckyDraw($event)"
    />
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsProfile from '@/core/Account/service/BzbsProfile'
import AlertError from '@/components/Modal/AlertError'
import Barcode from '@/components/Modal/BarCode'
import AddressEdit from '@/components/Modal/AddressEdit'
import Cache from '@/helper/Cache.js'
import BzbsStamp from '@/core/Home/BzbsStamp'
import Account from '@/helper/AccountHelper.js'
import SendVerifyEmail from '@/components/Modal/SendVerifyEmail'
import Locale from '@/helper/Locale.js'
import ConfirmLuckyDraw from '@/components/Modal/LuckyDraw/Confirm'
import SuccessLuckyDraw from '@/components/Modal/LuckyDraw/Success'
import moment from 'moment'

export default {
  name: 'CampaignDetail',
  components: {
    AlertError,
    Barcode,
    AddressEdit,
    SendVerifyEmail,
    ConfirmLuckyDraw,
    SuccessLuckyDraw,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      KEY_COOKIE_LOCALE: 'BzbsLocale',
      currentLocale: Locale.getLocale(),
      isShowModalSelectPackage: false,
      isShowModalRedeemPackageSuccess: false,
      isTypePackage: false,
      packageQTY: 0,
      ExpireDate: null,
      PackageVoucherExpireDate: null,
      type: '',
      imgCampaign: '',
      labelName: '',
      backgroundColor: '',
      textColor: '',
      showModalEditAddress: false,
      Campaign: {},
      PointPerUnit: 0,
      Detail: '',
      TermsAndConditions: '',
      showError: false,
      dataError: {},
      isDelivered: false,
      showBarcode: false,
      dataBarcode: {},
      showAddress: false,
      textPoint: null,
      isContinue: false,
      isPointNot: false,
      isStore: '',
      isConditionAlert: false,
      ConditionAlert: '',
      backgroundPointColor: '',
      textPointColor: '',
      dataStamp: {},
      showSendVerifyEmail: false,
      VerifiedEmail: false,
      LoginType: '',
      loginTypeList: [],
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
        levelmode: 'point',
      },
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      locale: '',
      profileUserId: '',
      profileLevel: {},
      currentLevel: null,
      redeemLevel: null,
      ads_id: '',
      showConfirmLuckyDraw: false,
      dataConfirmLuckyDraw: {},
      showSuccessLuckyDraw: false,
      dataSuccessLuckyDraw: {},
      FirstName: '',
      LastName: '',
      version: {},
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'modal-save-address-success') {
        window.location.href = '/home'
      }
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventShowLanguage)
  },
  created() {
    Account.bzbsAnalyticTracking(
      'campaign_detail_page',
      'campaign_detail_page',
      'view_campaign_detail_page',
      'on view',
    )
    this.checklocalStorage().then(() => {
      this.handleCheckLogin(this.$route)
      this.handleCheckRegister()
      this.init()
      window.addEventListener('resize', this.myEventShowLanguage)
    })
  },
  methods: {
    init() {
      this.handleLoading(false)
      this.handleFooter(false)
      this.myEventShowLanguage()
      this.locale = Cache.get('BzbsLocale')
      this.getCustomerStore().then(res => {
        if (res.StoreDetail.StoreType == 'stamp') {
          this.getStamp().then(() => {
            this.getProfile().then(() => {
              this.getCampaign()
            })
          })
        } else {
          this.getProfile().then(() => {
            this.getCampaign()
          })
        }
      })
    },
    //#region main
    myEventShowLanguage() {
      setTimeout(() => this.checkLanguage(), 300)
    },
    checkLanguage() {
      if (this.windowWidth >= 600 && this.windowHeight >= 600) {
        this.handleLanguage(true)
      } else {
        this.handleLanguage(false)
      }

      this.getCampaign()
    },
    getStamp() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsStamp.getStamp()
          .then(res => {
            this.handleLoading(false)
            this.dataStamp = res.data
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            console.log('getStamp error', error)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
    getProfile() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsProfile.getProfile(Account.getCacheToken())
          .then(res => {
            this.handleLoading(false)
            console.log('getProfile', res)
            this.profileUserId = res.data.UserId
            this.textPoint = res.data.updated_points.points
            this.VerifiedEmail = res.data.VerifiedEmail
            this.FirstName = res.data.FirstName
            this.LastName = res.data.LastName
            this.version.currect_terms = res.data.TermAndCondition
            this.version.currect_privacy = res.data.DataPrivacy
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getProfile error', error)
            resolve(error)
          })
      })
    },
    getCampaign() {
      this.handleLoading(true)
      var isStamp = false
      var cardId = ''
      if (this.isStore == 'stamp') {
        isStamp = true
        cardId = this.dataStamp.stamp.cardId
      }
      let params = {
        is_stamp: isStamp,
        id: this.$route.params.Id,
        type: 'places',
        redeem_media: 'stamp',
        walletcard: cardId,
      }
      if (this.$route.query.ads_id !== 'undefind' && this.$route.query.ads_id) {
        this.ads_id = this.$route.query.ads_id
        let lineProfile = Account.getCacheCustom(
          'profileLine_' + Account.getCacheCustom('app_id'),
        )
        BzbsProfile.bzbsAnalyticInitialReward(
          this.$route.params.Id,
          lineProfile.userId,
          this.profileUserId,
          this.$route.query.ads_id,
        )
      }
      return new Promise(resolve => {
        BzbsCampaign.getCampaign(params)
          .then(res => {
            this.handleLoading(false)
            console.log('getCampaign', res.data)
            this.Campaign = res
            this.genCampaign(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getCampaign error', error)
            resolve(error)
          })
      })
    },
    genCampaign(data) {
      this.getProfileLevel().then(() => {
        this.redeemLevel = this.getLevelList(data.UserLevel)
        console.log('++++++++++++++++++++++++redeemLevel', this.redeemLevel)

        this.type = data.Type
        this.isDelivered = data.Delivered
        this.PointPerUnit = data.PointPerUnit
        this.ConditionAlert = data.ConditionAlert
        var Url = data.Pictures[0].FullImageUrl.split('?', 1)
        var Time = data.Pictures[0].FullImageUrl.split('?')[1]
        this.imgCampaign = Url + '-large?' + Time
        if (this.redeemLevel.length && this.currentLevel) {
          if (!this.redeemLevel.includes(this.currentLevel)) {
            this.ConditionAlert =
              this.lbl.campaigndetail.condition_alert_unavailable_level ||
              'Unavailable level'
          }
        }
        this.checkTypePackage(data.Extra)
        this.ExpireDate = data.ExpireDate
        this.PackageVoucherExpireDate = data.Package
          ? data.Package.PackageVoucherExpireDate
          : null
        if (this.ConditionAlert != null && this.ConditionAlert != 'null') {
          this.isConditionAlert = true
          this.isPointNot = false
          this.isContinue = true
        } else if (
          this.textPoint < this.PointPerUnit &&
          data.Type != 8 &&
          data.InterfaceDisplay != 'survey'
        ) {
          this.isPointNot = true
          this.isContinue = true
          this.isConditionAlert = false
        } else {
          this.isContinue = false
          this.isPointNot = false
          this.isConditionAlert = false
        }

        setTimeout(() => this.genWording(data), 100)
      })
    },
    genWording(data) {
      var locale = Cache.get('BzbsLocale')
      if (locale === 'ph') {
        if (data.NameTH) {
          this.labelName = data.NameTH
          if (data.Detail) {
            this.Detail = data.Detail.replace(/\r?\n/g, '<br />')
            if (this.Detail) {
              document.getElementById('id_detail').innerHTML = this.Detail
            } else {
              this.Detail = ''
              document.getElementById('id_detail').innerHTML = this.Detail
            }
          } else {
            this.Detail = ''
            document.getElementById('id_detail').innerHTML = this.Detail
          }
          if (data.Condition) {
            this.TermsAndConditions = data.Condition.replace(/\r?\n/g, '<br />')
          } else {
            this.TermsAndConditions = ''
          }
        } else {
          this.labelName = data.NameEN
          if (data.DetailEN) {
            this.Detail = data.DetailEN.replace(/\r?\n/g, '<br />')
            document.getElementById('id_detail').innerHTML = this.Detail
          } else {
            this.Detail = ''
            document.getElementById('id_detail').innerHTML = this.Detail
          }
          if (data.ConditionEN) {
            this.TermsAndConditions = data.ConditionEN.replace(
              /\r?\n/g,
              '<br />',
            )
          } else {
            this.TermsAndConditions = ''
          }
        }
      } else if (locale === 'en') {
        this.labelName = data.NameEN
        if (data.DetailEN) {
          this.Detail = data.DetailEN.replace(/\r?\n/g, '<br />')
          if (this.Detail) {
            document.getElementById('id_detail').innerHTML = this.Detail
          } else {
            this.Detail = ''
            document.getElementById('id_detail').innerHTML = this.Detail
          }
        } else {
          this.Detail = ''
          document.getElementById('id_detail').innerHTML = this.Detail
        }
        if (data.ConditionEN) {
          this.TermsAndConditions = data.ConditionEN.replace(/\r?\n/g, '<br />')
        } else {
          this.TermsAndConditions = ''
        }
      } else {
        this.labelName = data.NameTH
        if (data.Detail) {
          this.Detail = data.Detail.replace(/\r?\n/g, '<br />')
          if (this.Detail) {
            document.getElementById('id_detail').innerHTML = this.Detail
          } else {
            this.Detail = ''
            document.getElementById('id_detail').innerHTML = this.Detail
          }
        } else {
          this.Detail = ''
          document.getElementById('id_detail').innerHTML = this.Detail
        }
        if (data.Condition) {
          this.TermsAndConditions = data.Condition.replace(/\r?\n/g, '<br />')
        } else {
          this.TermsAndConditions = ''
        }
      }
    },
    checkTypePackage(extra) {
      if (extra) {
        var js = JSON.parse(extra)
        var packages
        if (typeof js.packages !== 'string') {
          packages = js.packages
        } else {
          try {
            packages = JSON.parse(js.packages)
          } catch {
            packages = null
          }
        }

        if (packages && packages.length && packages[0].id && packages[0].qty) {
          this.isTypePackage = true
          this.packageQTY = packages[0].qty ? packages[0].qty : 0
        } else {
          this.isTypePackage = false
          this.packageQTY = null
        }
      } else {
        this.isTypePackage = false
        this.packageQTY = null
      }
    },
    changeTabs(e) {
      if (e == 2) {
        setTimeout(
          () =>
            (document.getElementById(
              'id_terms',
            ).innerHTML = this.TermsAndConditions),
          10,
        )
      } else {
        document.getElementById('id_detail').innerHTML = this.Detail
      }
    },
    getProfileLevel() {
      var params = {
        token: Account.getCacheToken() ? Account.getCacheToken() : null,
      }

      if (this.storeinfo.levelmode == 'spending') {
        return new Promise(resolve => {
          BzbsProfile.getProfileLevelSpending(params)
            .then(res => {
              this.handleLoading(false)
              this.currentLevel = res.data.data.currentLevel
              resolve(res.data)
            })
            .catch(error => {
              console.log(error)
              this.handleLoading(false)
              resolve(error)
            })
        })
      } else {
        return new Promise(resolve => {
          BzbsProfile.getProfileLevel(params)
            .then(res => {
              this.handleLoading(false)
              this.currentLevel = res.data.data.currentLevel
              resolve(res.data)
            })
            .catch(error => {
              console.log(error)
              this.handleLoading(false)
              resolve(error)
            })
        })
      }
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genCustomerStore(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    arrList(string) {
      var list = string.split(',')
      this.loginTypeList = list
      return list
    },
    genCustomerStore(data) {
      this.backgroundColor = data.StoreDetail.ButtonColor
      this.textColor = data.StoreDetail.ButtonTextColor
      this.backgroundPointColor = data.StoreDetail.PointButtonBackgroundColor
      this.textPointColor = data.StoreDetail.PointButtonTextColor
      this.isStore = data.StoreDetail.StoreType
      this.LoginType = data.StoreDetail.LoginType
      this.arrList(this.LoginType)
      this.storeinfo.image_header = data.StoreDetail.CoverUrl
      this.storeinfo.image_logo = data.StoreDetail.LogoUrl
      this.storeinfo.businessName = data.StoreDetail.BusinessName
      this.storeinfo.levelmode = data.StoreDetail.levelmode
      this.version.last_terms = data.TermAndCondition.Version
      this.version.last_privacy = data.PrivacyPolicy.Version
    },
    //#endregion main

    //#region Redeem
    handleRedeem() {
      Account.bzbsAnalyticTracking(
        'campaign_detail_page',
        'campaign_detail_page',
        'click_continue_campaign_detail',
        'on click',
      )
      if (this.isTypePackage) {
        this.isShowModalSelectPackage = true
      } else {
        var path =
          window.location.origin + '/campaigndetail/' + this.$route.params.Id
        this.checkPdpaVersion(this.version, path).then(res => {
          if (res) {
            if (
              this.VerifiedEmail == false &&
              this.loginTypeList.includes('Email') &&
              !this.loginTypeList.includes('Facebook')
            ) {
              this.showSendVerifyEmail = true
            } else {
              if (this.type == 0) {
                this.openConfirmLuckyDraw()
              } else if (this.type == 8) {
                this.openWebsite()
              } else {
                this.$refs['my-modal-confirm'].show()
              }
            }
          }
        })
      }
    },
    handleRedeemPackage() {
      var path =
        window.location.origin + '/campaigndetail/' + this.$route.params.Id
      this.checkPdpaVersion(this.version, path).then(res => {
        if (res) {
          if (
            this.VerifiedEmail == false &&
            this.loginTypeList.includes('Email') &&
            !this.loginTypeList.includes('Facebook')
          ) {
            this.showSendVerifyEmail = true
          } else {
            this.handleLoading(true)
            let params = {}
            if (this.isStore == 'stamp') {
              params = {
                redeem_media: 'stamp',
                walletcard: this.dataStamp.stamp.cardId,
                type: 'places',
                device_locale: Cache.get('BzbsLocale') == 'th' ? 1054 : 1033,
                info2: this.ads_id ? this.ads_id : '',
                shippingFirstName: this.FirstName,
                shippingLastName: this.LastName,
              }
            } else {
              params = {
                info2: this.ads_id ? this.ads_id : '',
                shippingFirstName: this.FirstName,
                shippingLastName: this.LastName,
              }
            }
            return new Promise(resolve => {
              BzbsCampaign.postCampaign(this.$route.params.Id, params)
                .then(res => {
                  this.handleLoading(false)
                  this.isShowModalSelectPackage = false
                  this.isShowModalRedeemPackageSuccess = true
                  console.log('postCampaign', res)

                  resolve(res.data)
                })
                .catch(error => {
                  this.handleLoading(false)
                  this.isShowModalSelectPackage = false
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: error.response.data.error.message,
                  }
                  console.log('postCampaign error', error.response.data)
                  resolve(error)
                })
            })
          }
        }
      })
    },
    goRewards() {
      this.$router.push({ name: 'myrewards', query: { tab: 'packages' } })
    },
    handleCancel() {
      Account.bzbsAnalyticTracking(
        'campaign_detail_page',
        'campaign_detail_page',
        'click_cancel_redeen_campaign_detail',
        'on click',
      )
      this.$refs['my-modal-confirm'].hide()
    },
    handleConfirm() {
      Account.bzbsAnalyticTracking(
        'campaign_detail_page',
        'campaign_detail_page',
        'click_confirm_redeen_campaign_detail',
        'on click',
      )
      this.$refs['my-modal-confirm'].hide()
      if (this.type == 1 && this.isDelivered == true) {
        this.showAddress = true
      } else {
        this.postCampaign()
      }
    },
    shuffleToken(bzbtoken) {
      return (
        bzbtoken.substring(bzbtoken.length - 5, bzbtoken.length) +
        bzbtoken.substring(1, bzbtoken.length - 5)
      )
    },
    openWebsite() {
      this.handleLoading(true)
      var token = this.shuffleToken(
        Account.getCacheToken() ? Account.getCacheToken() : null,
      )

      let theme = 'CRMPlus'
      let Locale = Cache.get('BzbsLocale') == 'th' ? 1054 : 1033

      window.open(
        this.Campaign.data.Website +
          '&theme=' +
          theme +
          '&return_url=' +
          encodeURI(window.location.origin + '/home') +
          '&locale=' +
          Locale +
          '&token=' +
          token,
        '_self',
      )
    },
    //#endregion Redeem

    //#region Delivery
    postCampaign() {
      this.handleLoading(true)
      let params = {}
      if (this.isStore == 'stamp') {
        params = {
          redeem_media: 'stamp',
          walletcard: this.dataStamp.stamp.cardId,
          type: 'places',
          device_locale: Cache.get('BzbsLocale') == 'th' ? 1054 : 1033,
          info2: this.ads_id ? this.ads_id : '',
          shippingFirstName: this.FirstName,
          shippingLastName: this.LastName,
        }
      } else {
        params = {
          info2: this.ads_id ? this.ads_id : '',
          shippingFirstName: this.FirstName,
          shippingLastName: this.LastName,
        }
      }
      return new Promise(resolve => {
        BzbsCampaign.postCampaign(this.$route.params.Id, params)
          .then(res => {
            this.handleLoading(false)
            console.log('postCampaign', res)
            this.showBarcode = true
            this.dataBarcode = {
              code: res.data.Serial,
              name: this.Campaign.data.Name,
              image: this.Campaign.data.Pictures[0].FullImageUrl,
              privilege_format: res.data.PrivilegeMessageFormat,
              privilege_message: res.data.PrivilegeMessage,
              privilege_message_en: res.data.PrivilegeMessageEN,
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('postCampaign error', error.response.data)
            resolve(error)
          })
      })
    },
    ChangeBarcode(event) {
      if (!event) {
        Account.bzbsAnalyticTracking(
          'campaign_detail_page',
          'campaign_detail_page',
          'click_hide_barcode_campaign_detail',
          'on click',
        )
      }
      this.showBarcode = event
      this.dataBarcode = {}
      this.getProfile().then(() => {
        this.getCampaign()
      })
    },
    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
    ChangeSendVerifyEmail(event) {
      this.showSendVerifyEmail = event
      this.getProfile()
    },
    //#endregion Delivery

    //#region Edit Address
    ChangeAddress(event) {
      this.showAddress = event.show
      if (event.success == true) {
        this.$refs['my-modal-save-address-success'].show()
      }
    },
    //#endregion Edit Address

    //#region Lucky Draw
    openConfirmLuckyDraw() {
      console.log('openConfirmLuckyDraw')
      this.dataConfirmLuckyDraw = {
        img: this.imgCampaign,
        title: this.labelName,
        pointperunit: this.PointPerUnit,
        type: this.type,
        backgroundColor: this.backgroundColor,
        textColor: this.textColor,
      }
      this.showConfirmLuckyDraw = true
    },
    closeLuckyDraw(event) {
      console.log('closeLuckyDraw : ', event)
      this.dataConfirmLuckyDraw = {}
      this.showConfirmLuckyDraw = false
    },
    submitConfirm(event) {
      if (event) {
        this.postCampaignLuckyDraw().then(res => {
          if (res.status == 200) {
            this.dataSuccessLuckyDraw = {
              img: this.imgCampaign,
              title: this.labelName,
              pointperunit: this.PointPerUnit,
              type: this.type,
            }
            this.showSuccessLuckyDraw = true
          }
        })
      }
    },
    successLuckyDraw(event) {
      this.dataSuccessLuckyDraw = {}
      this.showSuccessLuckyDraw = false
      if (event) {
        this.$router.push({ name: 'home' })
      }
    },
    postCampaignLuckyDraw() {
      this.handleLoading(true)
      let params = {}
      if (this.isStore == 'stamp') {
        params = {
          redeem_media: 'stamp',
          walletcard: this.dataStamp.stamp.cardId,
          type: 'places',
          device_locale: Cache.get('BzbsLocale') == 'th' ? 1054 : 1033,
          info2: this.ads_id ? this.ads_id : '',
        }
      } else {
        params = {
          info2: this.ads_id ? this.ads_id : '',
        }
      }
      return new Promise(resolve => {
        BzbsCampaign.postCampaign(this.$route.params.Id, params)
          .then(res => {
            this.handleLoading(false)
            resolve(res)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
    //#endregion Lucky Draw

    displayIncludeReward(text) {
      try {
        return text.replace('{0}', this.packageQTY ? this.packageQTY : 0)
      } catch {
        return 'This package include 0 Rewards'
      }
    },
    dateExpirePackage: function (timestamp, isdonotshowtime) {
      moment.locale(Locale.getLocale())
      var strDate = moment.unix(timestamp).utc().format('DD MMM ')
      var year = moment.unix(timestamp).utc().format('YYYY')
      var strtime = moment.unix(timestamp).utc().format('HH:mm')
      year = this.getYearByLocale(year)
      if (moment.locale(Locale.getLocale()) == 'th') {
        year = this.substring(year)
      }
      var time = ''
      if (isdonotshowtime) {
        time = strDate + year
      } else {
        time = strDate + year + ' - ' + strtime
      }

      return time
    },
    dateShortFormatUTC: function (timestamp, isdonotshowtime) {
      moment.locale(Locale.getLocale())
      if (timestamp) {
        var strDate = moment.unix(timestamp).utc().format('DD MMM ')
        var year = moment.unix(timestamp).utc().format('YYYY')
        var strtime = moment.unix(timestamp).utc().format('HH:mm')
        year = this.getYearByLocale(year)
        if (moment.locale(Locale.getLocale()) == 'th') {
          year = this.substring(year)
        }
        var time = ''
        if (isdonotshowtime) {
          time = strDate + year
        } else {
          time = strDate + year + ' - ' + strtime
        }

        return time
      } else {
        return '-'
      }
    },
    substring(value) {
      var str = value
      return str
    },
    getYearByLocale: function (year) {
      if (Locale.getLocale() == 'th') {
        return parseInt(year) + 543
      } else {
        return year
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
.wrapper-campaigndetail {
  .event-none {
    pointer-events: none;
  }
  .continue {
    background-color: #bbbbbb !important;
  }

  .image-back {
    position: fixed;
    z-index: 1;
  }

  .box-img {
    margin: 20px;
    border-radius: 15px;
    border: solid 1px #eee;
    overflow: hidden;
    text-align: -webkit-center;
  }

  .img-campaign {
    width: 100%;
    height: 100%;
  }

  .box-label-detail {
    margin: 10px 40px;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    word-break: break-word;
  }
  .box-label-detail-package {
    display: flex;
    align-items: center;
    gap: 4px;
    .qty {
      white-space: nowrap;
      max-width: 100px;
      min-width: fit-content;
      text-overflow: ellipsis;
      overflow: hidden;
      background: #191919;
      border-radius: 30px;
      padding: 2px 8px;
      color: #ffffff;
      width: fit-content;
      display: flex;
      align-items: center;
      .prefix {
        font-size: 10px;
      }
      .number {
        font-size: 12px;
      }
    }
  }
  .detail-package {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 0px 20px;
    .expire {
      font-size: 12px;
      color: #999999;
    }
  }

  .ant-tabs-bar {
    margin: 0px 25px 16px;
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;
    outline: none;
  }

  .box-detail {
    margin: 0px 25px;
    text-align: left;
    word-break: break-word;
  }

  .btn-redeem {
    width: 100%;
    height: 40px;
    font-size: 20px;
    font-weight: 600;
    line-height: 2;
    letter-spacing: normal;
    text-align: center;
    justify-content: center;
    vertical-align: middle;
    color: #fff;
  }

  .btn-redeem-not {
    width: 100%;
    height: 40px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.5;
    padding: 0px 50px;
    letter-spacing: normal;
    text-align: center;
    justify-content: center;
    vertical-align: middle;
    color: #fff;
  }

  .btn-redeem-alert {
    width: 100%;
    min-height: 40px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
    padding: 0;
    letter-spacing: normal;
    text-align: center;
    justify-content: center;
    vertical-align: middle;
    color: #fff;
    display: flex;
    align-items: center;
  }

  .menua:active,
  a:hover {
    text-decoration: none;
    outline: 0;
    opacity: 0.95;
  }

  .ant-tabs-nav .ant-tabs-tab {
    width: initial !important;
    padding: 5px 10px;
  }

  .wrapper-detail {
    .ant-tabs-nav .ant-tabs-tab {
      padding: 15px 10px;
      color: #a3a3a3;
      border: transparent !important;
      background-color: transparent !important;
    }

    .ant-tabs-nav .ant-tabs-tab-active {
      color: #2a2a2a !important;
      font-weight: 700;
    }

    .ant-tabs-ink-bar {
      background-color: #2a2a2a !important;
    }

    .ant-tabs-bar {
      margin: 0px 25px 16px;
      border-bottom: 1px solid #dfdfdf;
      border-top: 1px solid #dfdfdf;
      outline: none;
    }
  }

  .menu-resize {
    height: initial !important;
  }
}

.wrapper-campaigndetail {
  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
    .wrapper__campaigndetail__page {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      margin-top: -50px;
      background-color: white;
      .title {
        padding: 10px;
        .text-title {
          font-size: 18px;
          font-weight: 500;
          margin-left: 10px;
          color: #666;
          line-height: 1.17;
        }
      }
      padding: 0px 5px;

      .wrapper_hearder {
        padding: 20px 20px 0 20px;
      }

      .wrapper_content {
        padding: 0 20px 0 20px;
      }

      .label__checkbox {
        text-indent: 15px;
        position: absolute;
        top: -5px;
      }
      .radio-label {
        margin: 0 0 0 4px;
        font-size: 16px;
        letter-spacing: normal;
        text-align: left;
        color: $color-text-dark;
        white-space: nowrap;
        @include breakpoint-max(320) {
          font-size: 11px;
        }
      }
      .p-row {
        padding: 0px 0px 20px 0px !important;
        font-size: 16px;
      }
      .input__resetpassword {
        text-indent: 10px;
        width: 100%;
        height: 50px;
        border-radius: 10px;
        border: solid 1px $color-input;
        background-color: #fff;
      }
      .select__resetpassword {
        text-align: center;
        padding: 15px 0px 14px 0px;
        border-radius: 10px;
        border: solid 1px $color-input;
        width: 100%;
        background-color: #fff;
        @include breakpoint-max(320) {
          padding: 7px 0px 5px 0px !important;
        }
      }

      .checkbox__condition {
        width: 20px;
        height: 20px;
      }
    }

    height: 100%;
    width: 100%;
    .wrapper__campaigndetail__page {
      width: 90%;
      top: 20%;
      margin-top: 20px;
      margin-bottom: 50px;
      border-radius: 10px;
      .wrapper_content {
        padding: 0 0px 0 20px;
        margin-right: -15px;
      }
    }

    .image__hearder {
      height: 100%;
      overflow: auto;
      background-repeat: round;
      background-size: cover;
    }

    .box_content {
      min-height: 100%;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      vertical-align: middle;
      display: flex;
      width: 100%;
    }

    .logo__loginpage {
      width: 110px !important;
      background-size: contain;
      border-radius: 60px;
      height: 110px;
      margin-top: -67px;
    }

    .text-title {
      padding: 0 65px;
    }

    .footer {
      padding-bottom: 0;
      .container {
        position: relative;
      }
    }

    .image-back {
      margin-left: -15px;
      top: -60px;
      position: relative;
    }

    .box-label-detail {
      padding: 10px 0 15px 0;
      margin: 0;
      font-size: 32px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #424242;
      word-break: break-word;
    }

    .btn-crm-l {
      height: 32px;
    }

    .ant-btn-round {
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      flex-grow: 0;
    }

    .ant-tabs-nav-scroll {
      font-size: 18px;
      color: #757575;
      letter-spacing: -0.33px;
      font-weight: 600;
    }

    .ant-tabs-nav .ant-tabs-tab:hover {
      color: #033a70;
    }

    .ant-tabs-nav .ant-tabs-tab-active {
      color: #033a70;
      letter-spacing: -0.33px;
      font-weight: 600;
      font-size: 18px;
    }

    .ant-tabs-ink-bar {
      background-color: #033a70;
    }

    .content_page {
      margin-top: -60px;
    }
  }

  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) and (orientation: landscape) {
    .wrapper__campaigndetail__page {
      margin-top: 80px !important;
      margin-bottom: 100px !important;
    }
  }

  @media only screen and (min-device-width: 900px) {
    .wrapper__campaigndetail__page {
      width: 75%;
    }
  }

  @media only screen and (min-device-width: 1200px) {
    .wrapper__campaigndetail__page {
      width: 60%;
    }
  }
}

.modal-EditAddress {
  .label-address {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #999;
  }
}

.modal-EditAddress .ant-modal {
  top: 0;
}

.modal-title {
  font-size: 15px;
  font-weight: 600;
}

.ant-modal-footer {
  text-align: center;
}

.btn-cancel {
  background-color: #cfcfcf;
  border-color: #cfcfcf;
  color: rgb(0, 0, 0);
}

.btn-confirm {
  background-color: orange;
  border-color: orange;
  color: #fff;
}

button.btn.b-modal-header.btn-secondary.btn-lg {
  color: rgba(0, 0, 0, 0.45);
  background-color: transparent;
  border: initial;
  padding: 0;
  margin: 0;
  line-height: 0;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.45);
}

.w-70 {
  width: 70%;
}
.wrapper-popup-select-package {
  .mask-popup-select-package {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #181c32;
    z-index: 1;
    opacity: 0.3;
  }
  .popup-select-package {
    background-color: #ffffff;
    width: 100%;
    z-index: 2;
    position: absolute;
    bottom: 0;
    height: 80%;
    padding: 16px;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    .top {
      display: flex;
      justify-content: space-between;
      .title {
        display: flex;
        gap: 4px;
        align-items: flex-start;

        strong {
          color: #4a4a4a;
          font-size: 16px;
          font-weight: 700;
        }
        .qty {
          white-space: nowrap;
          max-width: 100px;
          min-width: fit-content;
          text-overflow: ellipsis;
          overflow: hidden;
          background: #191919;
          border-radius: 30px;
          padding: 2px 8px;
          color: #ffffff;
          width: fit-content;
          .prefix {
            font-size: 10px;
          }
          .number {
            font-size: 12px;
          }
        }
      }
      .close {
      }
    }
    .center {
      overflow: hidden;
      overflow-y: overlay;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
      .campaign-card {
        height: 140px;
        max-width: 500px;
        border-radius: 12px;
        border: 1px solid #c9c9c9;
        background-color: #ffffff;
        display: flex;
        gap: 12px;
        .box-img {
          flex: 1;
        }
        .detail {
          flex: 1.2;
          padding: 8px;
          padding-left: 0px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          .name {
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;
            text-align: left;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .expire {
            font-size: 12px;
            line-height: 14px;
          }
        }
      }
    }
    .bottom {
      border-top: 1px solid #dfdfdf;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-top: 4px;
      .package-noted {
        display: flex;
        flex-direction: column;
        color: #757575;
        line-height: 22px;
        text-align: left;
      }
      .btn-redeem-package {
        height: 53px;
        display: block;
        border-radius: 100px;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin: auto;
      }
    }
  }

  @media screen and (min-width: 600px) {
    .popup-select-package {
      .center {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      .bottom {
        margin-bottom: 40px;
      }
    }
  }
  @media screen and (min-width: 1112px) {
    .popup-select-package {
      .center {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
      }
      .bottom {
        margin-bottom: 40px;
      }
    }
  }
}
.redeem-package-success-modal {
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;

    .content {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
      }
      .campaign-name {
        background: #f5f5f5;
        line-height: 22px;
        text-align: left;
        color: #757575;
        width: 100%;
        padding: 8px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
      }
    }
    .footer {
      width: 100%;
      .btn-go-rewards {
        height: 53px;
        display: block;
        border-radius: 100px;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin: auto;
      }
    }
  }
}
</style>
